/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.17.0-32-g054b9b1a-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const RecordingKind = {
    Terminal: 'Terminal',
    Traffic: 'Traffic'
};
export function instanceOfRecordingKind(value) {
    for (const key in RecordingKind) {
        if (Object.prototype.hasOwnProperty.call(RecordingKind, key)) {
            if (RecordingKind[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function RecordingKindFromJSON(json) {
    return RecordingKindFromJSONTyped(json, false);
}
export function RecordingKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RecordingKindToJSON(value) {
    return value;
}
